module.exports = __webpack_public_path__ + "img/www.opentable.com.b0e31422.png";